import React from 'react';
import PropTypes from 'prop-types';
import { Button } from './Button';
import css from './Newsletter.css';

const Newsletter = () => {
  const handleJoinWhatsApp = () => {
    window.open('https://chat.whatsapp.com/FbPjCH2iS1DDoI7cOsG2Pn', '_blank');
  };

  return (
    <div className={css.newsletterContainer}>
      <div className={css.newsletter}>
        <h2 className={css.title}>
          Únete a nuestro grupo VIP de WhatsApp
        </h2>
        <p className={css.subtitle}>
        Sé la primera en enterarte de los descuentos, tesoros y mejores deals 🔥
        </p>
        <Button
          onClick={handleJoinWhatsApp}
          variant="outline"
          className={css.subscribeButton}
        >
          Unirme al grupo VIP
        </Button>
      </div>
    </div>
  );
};

Newsletter.propTypes = {};

export default Newsletter; 